
import React, { createRef } from 'react';
import { HttpsRequest, GetAuth, Session, Alerts, Round, StopFlagBanner } from '../component/Utils';
import { Loading } from '../component/BaseComponent';

import DeviceMenu, { StyleComponent } from '../component/DeviceMenu';
import { MSG, URLENUM } from '../component/Texts'
import HeatMapControl from '../component/HeatmapUI';



const SECONDS_TTL = 30000;
const HEATMAP_INS: google.maps.visualization.HeatmapLayer[] | null[] = [];

type RiderProps = {
	show_marker: (data: mapData) => void;
	stat_data?: Record<string, any>;
	drivers: Record<string, string | number | null>[];
	loc_data: markerProp[];
	map?: google.maps.Map;
	center_marker: (lat: number, lng: number, data: Record<string, unknown> | null) => void;
	set_other_state: (data:Record<string, any>) => void ;
}

type RiderState = {

	display_menu: boolean;
	heatmapdisplay: boolean;
	currentday: number;
	isbusy: boolean;
	selected_device: Record<string, any> | null;
	heatmapdate: null | string;
	movement_data: MovementData;
	playstatus: boolean;
	last_stopped_index: number;
	distance_covered: string;
	drivers: Record<string, string | number | null>[];
	init_msg: string;

}


type mapAreaCallbackType = {
    body: bodyProp | Record<string, any>;
    errormsg?: string;
    status: number;
    httpcode?: number;
}


class DriversList extends React.Component<RiderProps, RiderState> {

	constructor(props: RiderProps) {

		super(props);

		this.state = {
			display_menu: true, heatmapdisplay: false, currentday: 0,
			isbusy: false, selected_device: null, heatmapdate: null,
			movement_data: {
				data: [],
				total_rows: 0,
				rows_per_page: 50,
				pages: 0,
				page: 0,
			},
			last_stopped_index: 0,
			playstatus: false,
			distance_covered: "",
			drivers: [],
			init_msg: "checking for tracker data, please wait..."
		};

	}

	move_mode_ref = createRef<HTMLSelectElement>();


	toggle_menu = () => {
		this.setState({ display_menu: !this.state.display_menu });
	}

	center_mark_rider = (event: React.SyntheticEvent<HTMLButtonElement>) => {
		event.preventDefault();

		let data = JSON.parse(
			(event.currentTarget as HTMLElement).getAttribute('data-attr') as string
		);

		if (data.lat_val) {
			this.props.center_marker(Number(data.lat_val), Number(data.lng_val), data);
			return false;
		} else {
			this.props.center_marker(0, 0, null);
		}

		Alerts.show_info(MSG.NODATA);

	}


	get_last_pos_callback = (resp: callbackType) => {
		this.setState({isbusy: false}, ()=> this.props.show_marker(resp.body.map_data[0]))
	}

	get_last_pos = (device: number) => {
		// TODO: add a type def for this input
		this.setState({isbusy: true})
		HttpsRequest.get(
			URLENUM.last_seen,
			this.get_last_pos_callback,
			GetAuth(),
			{ device_info: String(device) }
		)
	}

	movement_mode_selection = (event: React.SyntheticEvent<HTMLSelectElement>) => {

		console.log(this.move_mode_ref.current?.value)
		// this change function has not done any thing yet 

	}
	locate_device = ({ lat, lng }: LngLatDataProp) => {

		if (lat === null || lat === 0) {
			Alerts.show_info(MSG.NOLOC);
			return
		}

		let anchor = document.createElement('a');
		anchor.setAttribute('href', URLENUM.google_search + `${lat},${lng}`);
		anchor.setAttribute('target', '_blank');
		anchor.click();

	}


	movement_history = (locinfo: Record<string, any>, datestr?: string) => {

		if (this.state.currentday > Number(Session.get("max_history_count"))) {
			Alerts.show_info(MSG.MAX_MOVEMENT_REACHED)
			return
		}

		HttpsRequest.get(
			URLENUM.movement_history,
			this.movement_callback,
			GetAuth(),
			{
				"device_info": locinfo.device_info,
				"day": String(this.state.currentday), 
				'date': datestr || ''
			}
		)

		this.setState({ selected_device: locinfo, isbusy: true });

	}

	movement_callback = ({ status, status_msg, body }: RespArgs) => {

		if (status !== 0) {
			Alerts.show_error(status_msg || MSG.APP_ERROR)
			return
		}

		const total_movements = body.movements.length;

		this.setState({
			movement_data: {
				data: body.movements,
				total_rows: total_movements,
				rows_per_page: 20,
				pages: this.get_pages(total_movements, 20),
				page: 0
			},
			isbusy: false, heatmapdisplay: true,
			heatmapdate: body.datevalue,
			playstatus: false,
			distance_covered: body.distance_covered
		});

	}


	reset_heatmap_data = (e: React.MouseEvent<HTMLButtonElement>) => {

		e.preventDefault();
		const { movement_data } = this.state;
		let resetpage = movement_data.page;
		if (movement_data.page === 0) resetpage = HEATMAP_INS.length;

		this.clear_prev_heatmap(resetpage);

		movement_data.page = 0;
		movement_data.rows_per_page = 20;
		movement_data.pages = this.get_pages(movement_data.total_rows, movement_data.rows_per_page);


		if (this.play_interval) clearInterval(this.play_interval)

		this.setState({
			movement_data: movement_data, last_stopped_index: 0,
			playstatus: false
		});

	}

	// stop_marker: markerStoreProp[] = [];
	play_interval: ReturnType<typeof setInterval> | null = null

	play_movement_intermitent = (
		movement_data: MovementData,
		last_stopped_index: number): Array<number | Array<google.maps.LatLng>> => {

		const point_data: google.maps.LatLng[] = [];

		const mvdata: HistoryMarkerType[] = movement_data.data;
		let item: HistoryMarkerType;
		let new_stop_index = 0;

		if (last_stopped_index >= mvdata.length) {

			Alerts.show_info(MSG.MovementEnd);
			this.setState({
				last_stopped_index: 0 // reset the index to 0
			})
			return [0, point_data]
		}

		for (var x = last_stopped_index; x < mvdata.length; x++) {

			item = mvdata[x];
			if (item['stopped_here']) {

				new_stop_index = x + 1;

				this.add_stop_marker(item)

				point_data.push(
					new google.maps.LatLng(item['lat'], item['lng'])
				)
				break;
			}
			point_data.push(
				new google.maps.LatLng(item['lat'], item['lng'])
			)
		}

		if (new_stop_index === 0) {
			new_stop_index = x;
		}

		return [new_stop_index, point_data]

	}

	play_movement_history = (movement_data: MovementData): Array<boolean | MovementData> => {

		movement_data.page++;

		if (movement_data.page > movement_data.pages) {
			movement_data.page = 0
			Alerts.show_info(MSG.MovementEnd);
			if (this.play_interval !== null)
				clearInterval(this.play_interval)

			return [false, movement_data]
		}

		return [true, movement_data]

	}

	render_gps_point_page = () => {

		const { data, page, rows_per_page } = this.state.movement_data;

		if (!this.state.playstatus) return

		const start = (page - 1) * rows_per_page,
			stop = ((page) * rows_per_page) - 1,
			current_data = data.slice(start, stop);

		const maps_data: google.maps.LatLng[] = [];
		current_data.map((item) => {
			if (item['stopped_here']) {
				this.add_stop_marker(item)
			}

			maps_data.push(new google.maps.LatLng(item['lat'], item['lng']));
		});

		this.draw_heatmap(maps_data);

	}
	clear_prev_heatmap = (array_pos: number) => {

		for (var c = 0; c < array_pos; c++) {
			HEATMAP_INS[c]?.setMap(null);
			HEATMAP_INS[c] = null;
		}
	}

	draw_heatmap = (data: google.maps.LatLng[]) => {

		if (data.length === 0) return

		const { page } = this.state.movement_data;
		const option = this.move_mode_ref.current?.value;
		const pos = data[data.length - 1];

		if (page % 10 === 0 && option === '1') {
			this.clear_prev_heatmap(page)
			this.props.map?.setCenter(pos)
		} else if (option === '2' || option === '3') {

			this.clear_prev_heatmap(page);
			this.props.map?.setCenter(pos);
		}

		const htmap = new google.maps.visualization.HeatmapLayer({
			data: data
		})

		htmap.setMap(this.props.map!);
		HEATMAP_INS[page] = htmap;

	}

	pop_array_index = (data: Array<any>, index: number) => {
		let ind = data.indexOf(index);
		if (ind !== -1)
			data.splice(ind, 1);
	}

	get_callback = (resp: mapAreaCallbackType) => {

        if (resp.status === -1) {
            alert(resp.errormsg)
            return false
        }

        let init_msg = this.state.init_msg; 
        if (resp.body.rider_data.length === 0){
            init_msg = 'No tracking devices found'
        } 

        this.setState({
            drivers: resp.body.rider_data,
            init_msg: init_msg
        	}, ()=> this.props.set_other_state({
        	map_data: resp.body.map_data,
            total_distance: resp.body.distance_covered
        	})
        )


    }

	componentDidMount(){
	//	HttpsRequest.get('/dashboard/locstatus', this.get_callback, GetAuth())
	}

	add_stop_marker = (
		{
			id,
			lat, lng,
			distance,
			time_spent,
			address_lookup,
			timestamp,
			stopped_here,
			icon
		}: HistoryMarkerType
	) => {

		let hours_elapsed = time_spent, unitmeasure = 'mins';

		if (time_spent > 0 && time_spent >= 60) {
			unitmeasure = 'hrs';
			hours_elapsed = (time_spent / 60);
		}

		hours_elapsed = Round(hours_elapsed);

		const infodata = StopFlagBanner({ address: address_lookup, timestamp: timestamp, hours: hours_elapsed, units: unitmeasure });

		const marker = new google.maps.Marker({
			position: { lat, lng },
			map: this.props.map,
			title: "stopped here for a while.",
			icon: icon
		})

		const infowindow = new google.maps.InfoWindow({

			content: infodata,
			ariaLabel: "rider"
		})

		marker.addListener("click", () => {
			infowindow.open({
				anchor: marker,
				map: this.props.map
			})
		})

		const clear_marker = () => marker.setMap(null);
		marker.addListener("dblclick", clear_marker);
		setTimeout(clear_marker, SECONDS_TTL)

	}


	traffic_stats = (device: string) => {

		HttpsRequest.get(
			URLENUM.traffic_simulation,
			this.traffic_stats_callback,
			GetAuth(),
			{ device_info: device }
		);
		this.setState({ isbusy: true });
	}


	traffic_stats_callback = ({ body, status, status_msg }: RespArgs) => { // TODO: fix this section properly

		this.setState({ isbusy: false });
		if (body.org === null || status !== 0) {
			Alerts.show_info(MSG.NORTDATA);
			return false
		}
		let anchor = document.createElement('a');
		anchor.setAttribute('href', URLENUM.google_traffic + `${body.org}/${body.dst}`);
		anchor.setAttribute('target', '_blank');
		anchor.click();
	}

	render() {

		return (<div className='posrel'>
			<div className={''}>
				<HeatMapControl
					display={this.state.heatmapdisplay}
					clearfunc={this.clearheatmap}
					startday={this.state.currentday}
					forwardfunc={this.forward}
					backwardfunc={this.backward}
					driver={this.state.selected_device}
					dateval={this.state.heatmapdate}
					distance={this.state.distance_covered}
					playfunc={this.set_play_trigger}
					ref={this.move_mode_ref}
					changefunc={this.movement_mode_selection}
					playmode={this.state.playstatus}
					resetfunc={this.reset_heatmap_data}
					pause_func={this.pause_play}
					set_date_func={this.specify_date}
				/>
				<div className=''>
					<table className="table table-hover table-stripes">
						<thead>
							<tr>
								<th> Type </th>
								<th> Vehicle </th>
								<th> Vehicle No </th>
								<th style={{ width: '5%' }}> Menu </th>
							</tr>
						</thead>
						<tbody>
							{
								this.props.drivers.map((item, idx) => (
									<DeviceMenu key={`drv${idx}`}
										getlocation={this.locate_device}
										data={item}
										rider_focus={this.center_mark_rider}
										LastPos={this.get_last_pos}
										Movement={this.movement_history}
										loc={this.props.loc_data}
										traffic_func={this.traffic_stats}
									/>)
								)
							}
							{
                                this.props.drivers.length === 0? (
                                    <tr> 
                                        <td colSpan={4} className='center'>
                                            <i> {this.state.init_msg} </i> 
                                        </td> 
                                    </tr>
                                ): null 
                            }
						</tbody>
					</table>
				</div>
				<br />
 
				<StyleComponent />
			</div>


			{this.state.isbusy && <Loading />}
		

		</div >
		)
	}

	get_pages = (total_rows: number, rows_per_page: number) => {

		let remainder = total_rows % rows_per_page;
		let pages = 0;

		if (remainder > 0) {
			pages = (total_rows - remainder) / rows_per_page + 1
		} else {
			pages = total_rows / rows_per_page
		}

		return pages

	}

	clear_heatmap_data() {
		const { page } = this.state.movement_data;
		this.clear_prev_heatmap(page + 1);
	}

	clearheatmap = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();

		const { movement_data } = this.state;
		this.clear_prev_heatmap(movement_data.page + 1);

		movement_data.page = 0
		movement_data.rows_per_page = 20
		movement_data.pages = this.get_pages(movement_data.total_rows, movement_data.rows_per_page);

		this.setState({
			movement_data, heatmapdisplay: false,
			currentday: 0, last_stopped_index: 0
		});


	}

	forward = (e: React.MouseEvent<HTMLButtonElement>) => {
		// fetches data based on the most recent 
		// max is the current day which is 0 
		e.preventDefault();

		let day = this.state.currentday - 1;
		this.setState({ currentday: day, isbusy: true },
			() => this.movement_history(this.state.selected_device!)
		);
		this.clear_heatmap_data();
	}

	specify_date = (datestr:string) => {

        this.setState(
            {isbusy: true}, 
            () => this.movement_history(this.state.selected_device!, datestr)
        )

        this.clear_heatmap_data();

    }

	backward = (e: React.MouseEvent<HTMLButtonElement>) => {
		// fetches data based on the previous movements 
		// max of 6 days in the past  

		e.preventDefault();
		this.setState({ currentday: this.state.currentday + 1, isbusy: true },
			() => this.movement_history(this.state.selected_device!)
		)
		this.clear_heatmap_data();

	}

	pause_play = (e: React.MouseEvent<HTMLButtonElement>) => {

		e.preventDefault();
		const { movement_data } = this.state;

		clearInterval(this.play_interval!);
		this.setState({
			playstatus: false,
			last_stopped_index: movement_data.page
		});


	}

	set_play_trigger = (e: React.MouseEvent<HTMLButtonElement>) => {

		e.preventDefault();

		const option = this.move_mode_ref.current?.value;
		const { movement_data } = this.state;

		this.props.map?.setZoom(12);

		if (option === '2') {
			const [idx, point_data] = this.play_movement_intermitent(movement_data, this.state.last_stopped_index);

			this.setState({
				last_stopped_index: idx as number,
			}, () => this.draw_heatmap(point_data as google.maps.LatLng[]))

			return
		}

		if (option === '1') {
			// move slowly at intervals 
			this.play_interval = setInterval(() => {

				const resp = this.play_movement_history(movement_data)
				this.setState({
					movement_data: resp[1] as MovementData,
					playstatus: resp[0] as boolean
				}, this.render_gps_point_page)

			}, 1000)
		}

		else if (option === '3') {
			const total = movement_data.data.length;

			movement_data.rows_per_page = total;
			movement_data.pages = this.get_pages(total, total);
			this.setState({
				movement_data: movement_data
			},
				() => {
					const resp = this.play_movement_history(this.state.movement_data);
					this.setState(
						{
							movement_data: resp[1] as MovementData,
							playstatus: resp[0] as boolean
						},
						this.render_gps_point_page
					);

				}
			)
		}

	}


}




export default DriversList;